import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { first } from 'rxjs/operators';
import { go } from '@platform/router.actions';

import { RootState } from '@root/app.state';
import { RouteGuard } from '@platform/routing/route.guard';
import * as CoreActions from '@core/core.actions';

import { selectContacts } from '@core/core.selectors';
import { firstValueFrom } from 'rxjs';
import { ResourceStatuses } from '@platform/shared/resource.state';

@Injectable({
  providedIn: 'root',
})
export class ContactsGuard implements RouteGuard {
  constructor(private store$: Store<RootState>) {}

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    return await this.loadContacts(route);
  }

  async canActivateChild(childRoute: ActivatedRouteSnapshot): Promise<boolean> {
    return await this.loadContacts(childRoute.parent!);
  }

  private async loadContacts(route: ActivatedRouteSnapshot): Promise<boolean> {
    const customerSpaceId = route.parent!.paramMap.get('customerSpaceId');

    this.store$.dispatch(CoreActions.loadContacts({ customerSpaceId: customerSpaceId! }));

    const contactsState = await firstValueFrom(
      this.store$.pipe(
        select(selectContacts),
        first((x) => x.status === ResourceStatuses.FAILED || x.status === ResourceStatuses.SUCCEEDED),
      ),
    );

    const canActivate = contactsState.status === ResourceStatuses.SUCCEEDED;

    if (!canActivate) {
      this.store$.dispatch(go({ path: ['error'] }));
    }

    return canActivate;
  }
}
